var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDemo4(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 90,
    height: 90,
    viewBox: "0 0 90 90",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 90,
    height: 90,
    rx: 45,
    fill: "#FFF1C5"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M47.4975 20L47.495 23.195L59.995 27.365L69.0775 24.34L70.6575 29.08L63.08 31.6075L70.8175 52.8875C69.4193 54.3483 67.7392 55.5102 65.879 56.303C64.0188 57.0958 62.0171 57.5031 59.995 57.5C57.9733 57.5027 55.9721 57.0953 54.1123 56.3025C52.2526 55.5097 50.5729 54.348 49.175 52.8875L56.91 31.6075L47.495 28.4675V62.5H57.495V67.5H32.495V62.5H42.495V28.4675L33.08 31.6075L40.8175 52.8875C39.4198 54.3477 37.7406 55.5093 35.8813 56.3021C34.022 57.0948 32.0213 57.5024 30 57.5C27.9775 57.5034 25.9753 57.0964 24.1146 56.3035C22.254 55.5107 20.5735 54.3486 19.175 52.8875L26.9125 31.6075L19.3375 29.0825L20.9175 24.3375L30 27.3625L42.4975 23.195V20H47.4975ZM59.9975 37.7575L55.1 51.2225C56.5959 52.0613 58.2825 52.5012 59.9975 52.5C61.7475 52.5 63.4225 52.05 64.8925 51.225L59.9975 37.7575ZM29.9975 37.7575L25.1 51.2225C26.5959 52.0613 28.2824 52.5012 29.9975 52.5C31.7475 52.5 33.4225 52.05 34.8925 51.225L29.9975 37.7575Z",
    fill: "#FFAE00"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDemo4);
export default __webpack_public_path__ + "static/media/demo4.36c53f2c7dc204bae9afe5ca94694c97.svg";
export { ForwardRef as ReactComponent };